import "../assets/styles/home.css"

const MonthSelector = ({value, onMonthChange}) => {

    const handleMonthChange = (event) => {
        onMonthChange(event.target.value)
    }

    return (
        <select className="month" value={value} onChange={handleMonthChange} data-testid="month-filter">
            <option value="Month">Month</option>
            <option value="January">January</option>
            <option value="February">February</option>
            <option value="March">March</option>
            <option value="April">April</option>
            <option value="May">May</option>
            <option value="June">June</option>
            <option value="July">July</option>
            <option value="August">August</option>
            <option value="September">September</option>
            <option value="October">October</option>
            <option value="November">November</option>
            <option value="December">December</option>
        </select>
    )
}

export default MonthSelector;